import React, { useState } from "react";
import CustomRangePanelComponent from "./customRangePanel.component";

function CustomRangePanelContainer({
  formik,
  disabled,
  checkSNAvailability,
  updateQuantity,
  isSNexceedRange,
}) {
  const [isSameRange, setIsSameRange] = useState(false);

  const onCustomRangeChange = (event, name, index) => {
    formik.setFieldValue(name, event.target.value);
    setIsSameRange(false);
  };

  const submit = () => {
    const range = formik.getFieldProps("generateRanges").value;
    let sameRange = false;

    const total = range.reduce((sum, b) => {
      if (!Number.isNaN(b.start) && !Number.isNaN(b.end)) {
        const start = Number(b.start);
        const end = Number(b.end);
        return sum + (end - start + 1);
      }
      return sum;
    }, 0);
    updateQuantity(total);

    const tempRange = [];
    range.forEach((number, index) => {
      const start = Number(number.start);
      const end = Number(number.end);

      const overlap = range.findIndex((r, i) => {
        if (index !== i) {
          return (
            (r.start <= start && r.end >= end) ||
            (r.start >= start && r.start <= end) ||
            (r.end >= start && r.end <= end)
          );
        }
        return false;
      });

      if (overlap >= 0) {
        sameRange = true;
      }

      tempRange.push({
        start,
        end,
      });
    });
    formik.setFieldValue("generateRanges", tempRange);

    if (!sameRange) {
      checkSNAvailability(formik.values.generateRanges);
      // value check for submit assign serial number
      formik.setFieldValue("isSerialNumber", false);
      setIsSameRange(sameRange);
    } else {
      setIsSameRange(sameRange);
    }
  };

  return (
    <CustomRangePanelComponent
      formik={formik}
      onCustomRangeChange={onCustomRangeChange}
      isSameRange={isSameRange}
      isInputDisable={disabled}
      submit={submit}
      isSNexceedRange={isSNexceedRange}
    />
  );
}

export default CustomRangePanelContainer;
